import { create } from "zustand";

// create with the following
//   idToIdxMap, idxToIdList, offsetsByIdx

export const usePublicLayoutStore = create<{
  idToIdxMap: { [key: string]: number };
  idxToIdList: string[];
  offsetsById: { [key: number]: number };
  updateIdToIdxMap: (idToIdxMap: { [key: string]: number }) => void;
  updateIdxToIdList: (idxToIdList: string[]) => void;
  updateOffsetsById: (offsetsById: { [key: number]: number }) => void;
}>((set) => ({
  idToIdxMap: {},
  idxToIdList: [],
  offsetsById: {},
  updateIdToIdxMap: (idToIdxMap) => {
    set({ idToIdxMap });
  },
  updateIdxToIdList: (idxToIdList) => {
    set({ idxToIdList });
  },
  updateOffsetsById: (offsetsById) => {
    set({ offsetsById });
  },
}));
